import React, { FC, type Dispatch, type SetStateAction } from 'react'
import { FeedTabs } from 'pages/native/userFeed/types'

import { TabHeadingItem } from '../TabHeadingItem/TabHeadingItem'

import classes from './TabHeadingContainer.module.scss'

type TabHeadingContainerProps = {
  selectedTab: FeedTabs
  setSelectedTab: Dispatch<SetStateAction<FeedTabs>>
}

export const TabHeadingContainer: FC<TabHeadingContainerProps> = ({
  selectedTab,
  setSelectedTab
}) => {
  const tabs = Object.values(FeedTabs)

  const handleTabClick = (tab: FeedTabs) => {
    setSelectedTab(tab)
  }
  return (
    <div className={classes.Container}>
      <div className={classes.Tabs}>
        {tabs.map((tab, index) => (
          <TabHeadingItem
            key={index}
            tab={tab}
            isActive={tab === selectedTab}
            onClick={() => handleTabClick(tab)}
          />
        ))}
      </div>
    </div>
  )
}
